import { Box, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { useTriConnection } from './hooks';

const ObserverComponent = () => {

  const [isDisabled, setIsDisabled] = useState(true);
  const { data, isLoading, error, } = useTriConnection();

  const handleClick = () => {
    setIsDisabled((prev) => !prev);
  };

  const boxDimensions = {
    width: { xs: 170, sm: 190, md: 210, lg: 230, xl: 250, },
    height: { xs: 150, sm: 160, md: 170, lg: 180, xl: 190, },
  };

  return (
    <>
      <Box
        id="standalone-box"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: boxDimensions.width,
          height: boxDimensions.height,
          justifyContent: 'center',
          backgroundColor: 'var(--card)',
          boxShadow: 3,
          borderRadius: 4,
          padding: 2,
        }}
      >
        {/* <img src={standalone} alt="Standalone" /> */}
        <Box>
          <VisibilityIcon sx={{ fontSize: "2rem" }} />
        </Box>
        <Typography sx={{ mt: 1 }}>Observer</Typography>
        <Typography sx={{ mt: 1 }}>{data?.observer_address}</Typography>
        {/* <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
        <TextField id="input-with-sx" variant="standard"   disabled={isDisabled}/>
        <EditIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} onClick={handleClick}/>
      </Box> */}
        <Box>
          {/* <Typography>Active for 30d 12h</Typography> */}
        </Box>
      </Box>
    </>
  )
}

export default ObserverComponent